import type { ReactNode } from "react";
import { AlertTriangle, CircleAlert, Info } from "lucide-react";
import { cn } from "@/lib/cn";

type Tone = "info" | "warning" | "danger";

const TONES: Record<Tone, { box: string; Icon: typeof Info }> = {
    info: { box: "bg-brand-soft text-ink border-brand/20", Icon: Info },
    warning: { box: "bg-warning/10 text-ink border-warning/30", Icon: AlertTriangle },
    danger: { box: "bg-danger-soft text-ink border-danger/25", Icon: CircleAlert },
};

export function Alert({ tone = "info", children }: { tone?: Tone; children: ReactNode }) {
    const { box, Icon } = TONES[tone];

    return (
        <div className={cn("flex items-start gap-2.5 rounded-lg border px-3 py-2.5 text-sm", box)} role="alert">
            <Icon className="mt-0.5 size-4 shrink-0" aria-hidden />
            <div className="min-w-0">{children}</div>
        </div>
    );
}
